class Guide {

	static msg = '';


	constructor() {

	}


	/**
	 *
	 * @param msg
	 * @param icon
	 * @param items
	 */
	static displayHint(msg: string, icon: string, ...items: string[]): void {

		let msg_icon: string = (icon != '') ? '<i class="material-icons">' + icon + '</i>' : '';

		for (let i in items) {
			msg = msg.replace('%' + (Number(i) + 1), items[i]);
		}

		$('#hint-frame').removeClass().addClass('msg-hint').html(msg_icon + ' ' + msg);

	};


	static displayError(data): void {

		console.log('error:', data.message);
		let panel: string = '#modal-blank';

		$(panel).modal('toggle');

		$(panel + ' #msg').html(`<b>${data.name}</b>: ${data.message}`);

	};


	static displayPersistentNote(display: string, msg: string): void {

		$('#oos-alert .msg').html(msg);

		if (display == 'show') {

			$('#oos-alert').show();

		} else {

			$('#oos-alert').hide();

		}
	};

	/**
	 *
	 * @param msg
	 * @param icon
	 * @param items
	 */
	static displayAlert(msg: string, icon: string, ...items: string[]): void {

		let msg_icon: string = (icon != '') ? '<i class="material-icons">' + icon + '</i>' : '';

		for (let i in items) {
			msg = msg.replace('%' + (Number(i) + 1), items[i]);
		}

		$('#hint-frame').removeClass().addClass('msg-alert').html(msg_icon + ' ' + msg);

	};
}

export {Guide};

